import { Grid, selectClasses } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Input,
  Label,
  Row,
  Spinner,
  FormGroup,
  Alert,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import { useDropzone } from "react-dropzone";
import Attachment from "./Attachment";
import { useQuery } from "redux/action/api";
import { fetchApi, postApi } from "redux/action/api_tbeams";
import { apiURL } from "redux/action/api_tbeams";
import CapitalProject, { getDistinctObjects } from "./CapitalProject";
import WarningModal from "./WarningModal";
import { formatNumber } from "redux/action/api";
import { useToasts } from "helper/ToastAdapter";
import SelectedDataTable from "./SelectedDataTable";
import RealiseCollectionPdfWebView from "components/RealiseCollectionPdfWebView";
import NewRelisePdfWebView from "components/NewRelisePdfWebView";
import NewRecurrentMonthly from "./NewRecurrentMonthly";
import OtherOverheadExcelUpload from "./OtherOverheadExcelUpload";

import html2pdf from "html2pdf.js";
import { getSector } from "helper";
import { getMDaType } from "helper";
import { useSelector } from "react-redux";

export default function NewReleaseCollection({}) {
  const generateNarrationPDF = () => {
    const element = document.getElementById("pdf-preview");
    const options = {
      margin: 0.5,
      filename: "narration.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    html2pdf().set(options).from(element).save();
  };
  const query = useQuery();
  const mdacode = query.get("mda_code");
  const mdaRef = useRef();
  const economicRef = useRef();
  const ccMdaRef = useRef(); // For CC MDA selection
  const fundRef = useRef(); // For Fund Code
  const functionalRef = useRef(); // For Functional Code
  const programRef = useRef(); // For Program Code
  const geoRef = useRef(); // For Geo Code
  const navigate = useNavigate();
  const [fetching, setFetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showAmountWarningModal, setShowAmountWarningModal] = useState(false);
  const [submittingReserveRequest, setSubmittingReserveRequest] =
    useState(false);
  const [selectedBudget, setSelectedBudget] = useState({});

  const [economicCode, setEconomicCode] = useState([]);
  const [childCode, setChildCode] = useState([]);
  const economicTypeahead = useRef();
  const _id = query.get("id");
  const imageId = moment().format("YYYYMMDDhhmmss");
  const [showForm, setShowForm] = useState(true);
  const [filteredEconomicCode, setFilteredEconomicCode] = useState([]);
  const [distinctAdmins, setDistinctAdminCodes] = useState([]);
  const [allMdaAdmins, setAllMdaAdmins] = useState([]);
  const user = useSelector((e) => e.auth.user);
  const [form, setForm] = useState({
    collection_date: moment().format("YYYY-MM-DD"),
    approval_date: moment().format("YYYY-MM-DD"),
    mda_description: "",
    mda_budget_balance: "",
    mda_economic_code: "",
    approved_by: "HE",
    approved_amount: "",
    approval: "Approved",
    query_type: "insert",
    imageId,
    narration: "to facilitate the ",
    approval_no: "",
    approval_status: "Approval Initiated",
    add_remark: "",
    sent_to: {
      title: "",
      office: "",
    },
    mda_head: "",
    approval_type: "Recurrent",
    copies: {},
    copies1: {},
    cc_mda_name: "", // For CC MDA selection
    cc_copies: {}, // For CC MDA office data
    user_id: user.id,
    projectType: "Overhead",
  });

  const [showNarrationModal, setShowNarrationModal] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [balLoanding, setBalLoanding] = useState(false);
  const [attachedFiles, setAttachedFiles] = useState([]);

  const { addToast } = useToasts();

  const getCCCopies = useCallback(() => {
    postApi(`post-cc?query_type=select_mda`, { mda_name: form.mda_name })
      .then((data) => {
        console.log("data", data);
        if (data.results) {
          setForm((p) => ({ ...p, copies: data.results[0] }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [form.mda_name]);

  const getCCCopies1 = useCallback(() => {
    postApi(`post-cc?query_type=select_mda`, { mda_name: form.mda_head })
      .then((data) => {
        console.log("data", data);
        if (data.results) {
          setForm((p) => ({ ...p, copies1: data.results[0] }));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [form.mda_head]);

  const getCCCopiesForCC = useCallback(() => {
    if (form.cc_mda_name) {
      postApi(`post-cc?query_type=select_mda`, { mda_name: form.cc_mda_name })
        .then((data) => {
          console.log("CC data", data);
          if (data.results) {
            setForm((p) => ({
              ...p,
              cc: data.results[0]?.officeTitle,
            }));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [form.cc_mda_name]);

  useEffect(() => {
    getCCCopies();
    getCCCopies1();
    getCCCopiesForCC();
  }, [getCCCopies, getCCCopies1, getCCCopiesForCC]);

  // useEffect(() => {
  //   setForm((p) => ({ ...p, narration: "to facilitate the" }));
  // }, []);

  const handleAddToList = () => {
    if (
      !form.approval_no ||
      !form.mda_code ||
      !form.approved_amount ||
      (!form.mda_economic_code && !form.program_code)
    ) {
      addToast("Incomplete form. approval_no, mda_code, approved_amount, and either mda_economic_code or program_code are required.", {
        appearance: "error",
        autoDismiss: true,
        autoDismissTimeout: 5000,
      });
      return;
    }

    // Check if approval number already exists in current batch
    if (selectedData.some((item) => item.approval_no === form.approval_no)) {
      addToast(
        `Reference Number "${form.approval_no}" already exists in the current batch. Please use a different reference number.`,
        {
          appearance: "error",
          autoDismiss: true,
          autoDismissTimeout: 6000,
        },
      );
      return;
    }

    // Check if approval number already exists in database
    setIsLoading(true);
    postApi(`post_approval_collection`, {
      form: {
        query_type: "select_by_approval_nos",
        approval_no: form.approval_no,
      },
    })
      .then((data) => {
        if (data.success && data.result && data.result.length > 0) {
          // Approval number already exists
          addToast(
            `Reference Number "${form.approval_no}" already exists. Please use a different reference number.`,
            {
              appearance: "error",
              autoDismiss: true,
              autoDismissTimeout: 6000,
            },
          );
        } else {
          // Approval number is unique, proceed to add
          setSelectedData((prevData) => [...prevData, form]);
          setShowTable(true);
          setForm((p) => ({
            ...p,
            mda_description: "",
            mda_name: "",
            mda_budget_balance: "",
            mda_economic_code: "",
            narration: "to facilitate the",
            description: "",
            mda_code: "",
            approved_amount: "",
            // approval_type: "Recurrent",
            approval_status: "Approval Initiated",
            add_remark: "",
            sent_to: {
              title: "",
              office: "",
            },
          }));
          mdaRef?.current?.setState({ text: "" });
          economicRef?.current?.setState({ text: "" });

          addToast("Item added to batch successfully", {
            appearance: "success",
            autoDismiss: true,
            autoDismissTimeout: 3000,
          });
        }
      })
      .catch((err) => {
        console.error("Error checking approval number:", err);
        // Only show error if it's not a session expiration
        if (err.message !== "Session expired") {
          addToast("Error checking reference number. Please try again.", {
            appearance: "error",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleDeleteFromList = (index) => {
    setSelectedData((prevData) => prevData.filter((_, i) => i !== index));
    if (selectedData.length === 1) {
      setShowTable(false);
    }
  };

  const handleDeleteAttachment = (index) => {
    setAttachedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const submitPlanningReserveRequest = () => {
    setSubmittingReserveRequest(true);
    setIsLoading(true);
    form.sent_to_mda = form.sent_to.office || "";
    form.sent_to_office = form.sent_to.title || "";
    form.query_type = "insert";
    form.approval_status = "No Budget";
    postApi(`post_approval_collection`, { form })
      .then((data) => {
        if (data.success) {
          console.log(data);
          handleApi1(form.approval_no);

          postApi(`planning-reservation`, {
            destMdaCode: selectedBudget.admin_code,
            destEconomicCode: selectedBudget.economic_code,
            destMdaDescription: selectedBudget.admin_description,
            destEconomicDescription: selectedBudget.economic_description,
            destFundCode: selectedBudget.fund_code,
            destFundDescription: selectedBudget.fund_description,
            destFunctionalCode: selectedBudget.function_code,
            destFunctionalDescription: selectedBudget.function_description,
            destProgramCode: selectedBudget.program_code,
            destProgramDescription: selectedBudget.program_description,
            destGeoCode: selectedBudget.geo_code,
            destGeoDescription: selectedBudget.geo_description,
            approvedAmount: form.approved_amount,
            query_type: "insert",
            reserveStatus: "Pending",
            approvalNo: form.approval_no,
          })
            .then((data) => {
              if (data.success) {
                console.log(data);
                addToast("submit success", {
                  appearance: "info",
                  autoDismiss: true,
                  autoDismissTimeout: 5000,
                });
                setShowForm(false);
                navigate("/planning-reservation");
              }
            })
            .catch((err) => {
              addToast(err, {
                appearance: "error",
                autoDismiss: true,
                autoDismissTimeout: 5000,
              });
            })
            .finally(() => {
              setSubmittingReserveRequest(false);
            });
          setShowForm(false);
        }
      })
      .catch((err) => {
        addToast(err, {
          appearance: "error",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const { acceptedFiles, getRootProps, getInputProps, isDragActive } =
    useDropzone({ accept: "image/*, .pdf, text/plain" });

  // Sync acceptedFiles with attachedFiles state
  useEffect(() => {
    setAttachedFiles(acceptedFiles);
  }, [acceptedFiles]);

  const [steps, setSteps] = useState("1");
  const query_type =
    steps === "1" ? "recurrent" : steps === "2" ? "capital" : "";

  const getList = useCallback(() => {
    setFetching(true);
    fetchApi(`get-budget-summary?query_type=${query_type}`)
      .then((d) => {
        setFetching(false);
        if (d.result) {
          console.log(d, "ddkdjd");
          setEconomicCode(d.result);
          const distinctAdmins = getDistinctObjects(
            d.result,
            "admin_code",
            "admin_description",
          );
          setDistinctAdminCodes(distinctAdmins);
          setFetching(false);
        }
      })
      .catch((err) => {
        setFetching(false);
        console.log(err);
      });
  }, [query_type]);

  const getAllMdaAdmins = useCallback(() => {
    const loadType = async (type) => {
      return fetchApi(`get-budget-summary?query_type=${type}`)
        .then((d) => (d.result ? d.result : []))
        .catch((err) => {
          console.log(err);
          return [];
        });
    };

    Promise.all([loadType("recurrent"), loadType("capital")]).then(
      ([recurrentData, capitalData]) => {
        const merged = [...recurrentData, ...capitalData];
        const allAdmins = getDistinctObjects(
          merged,
          "admin_code",
          "admin_description",
        );
        setAllMdaAdmins(allAdmins);
      }
    );
  }, []);

  useEffect(() => {
    getList();
    getAllMdaAdmins();
  }, [getList, getAllMdaAdmins]);

  // useEffect(() => {
  //   postApi(`select_mda_bank_details`, {
  //     query_type: "select",
  //   }).then((data) => {
  //     if (data.result) {
  //       console.log(data.result);

  //       const treasuryAccount = data.result.filter(
  //         (item) => item.account_type === "treasury_source_account"
  //       );
  //       setTreasuryAccount(treasuryAccount);

  //       const mdaAccount = data.result.filter(
  //         (item) => item.account_type === "mda_source_account"
  //       );
  //       setMdaAccount(mdaAccount);
  //     }
  //   });
  // }, []);

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    if (type === "checkbox") {
      setForm((prev) => ({ ...prev, [name]: checked ? value : "" }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };
  const getBudgetBalance = useCallback(() => {
    setBalLoanding(true); // Add loading state
    postApi(`update_budget_balance`, {
      query_type: "select",
      mda_name: form.mda_name,
      mda_code: form.mda_code,
      amount: null,
      economic_code: form.mda_economic_code,
      geo_code: form.geo_code,
      program_code: form.program_code,
      functional_code: form.functional_code,
    })
      .then((d) => {
        console.log("data", d);
        if (d.success) {
          const selectedItem = d.data[0];
          setBalLoanding(false);
          setForm((p) => ({
            ...p,
            // description: selectedItem?.budget_description,
            mda_budget_balance:
              selectedItem?.mopb_balance == 0
                ? "Budget Exausted"
                : selectedItem?.mopb_balance,
            budget:
              selectedItem?.approve_amount == 0
                ? "Budget Exausted"
                : selectedItem?.approve_amount,
          }));
        }
      })
      .catch((err) => {
        // Handle errors
        setBalLoanding(false);
        console.log(err);
      })
      .finally(() => {
        setBalLoanding(false);
      });
  }, [
    form.mda_code,
    form.mda_head_code,
    form.projectType,
    form.geo_code,
    form.functional_code,
    form.program_code,
    form.mda_economic_code,
  ]);

  // Add useEffect to automatically update balance when key values change
  useEffect(() => {
    getBudgetBalance();
  }, [getBudgetBalance]);

  // ...existing code...

  const handleEconomicCode = (selected) => {
    if (selected?.length) {
      console.log("selected budget", selected);
      const selectedItem = selected[0];
      setSelectedBudget(selected[0]);
      setForm((p) => ({
        ...p,
        mda_economic_code: selectedItem.economic_code,
        description: selectedItem.economic_description,
        mda_description: selectedItem.economic_description,
      }));
      // Remove the direct call here since useEffect will handle it
      // getBudgetBalance(selectedItem.economic_code);
    } else {
      console.log("no item selected");
      // Clear budget balance when no economic code is selected
      setForm((p) => ({
        ...p,
        mda_economic_code: "",
        description: "",
        mda_description: "",
        mda_budget_balance: "",
        budget: "",
      }));
    }
  };

  const handleMdaCode = (selected) => {
    if (selected?.length) {
      console.log(selected);
      const selectedItem = selected[0];
      getMDaType(
        {},
        selectedItem.admin_code,
        (d) => {
          setForm((p) => ({ ...p, mda_sn: d[0]?.mda_sn || "" }));
        },
        "select_sn",
      );
      const filteredData = economicCode.filter(
        (item) =>
          item.admin_code === selectedItem.admin_code ||
          item.mda_code === selectedItem.admin_code,
      );

      // Set the filtered data for use in other dropdowns
      setFilteredEconomicCode(filteredData);

      setForm((p) => ({
        ...p,
        mda_code: selectedItem.admin_code,
        mda_name: selectedItem.admin_description,

        // Clear budget values when MDA changes
        mda_budget_balance: "",
        budget: "",
      }));
    } else {
      console.log("no item selected");
      setForm((p) => ({
        ...p,
        mda_code: "",
        mda_name: "",
        mda_sn: "",
        mda_budget_balance: "",
        budget: "",
      }));
    }
  };

  const handleMdaCode1 = (selected) => {
    if (selected?.length) {
      const selectedItem = selected[0];
      getMDaType(
        {},
        selectedItem.admin_code,
        (d) => {
          setForm((p) => ({ ...p, mda_sn: d[0]?.mda_sn || "" }));
        },
        "select_sn",
      );
      setForm((p) => ({
        ...p,
        mda_head_code: selectedItem.admin_code,
        mda_head: selectedItem.admin_description,
        send_to_office: selectedItem.admin_code,
        projectType: "payable-to",
        // Clear budget values when MDA head changes
        mda_budget_balance: "",
        budget: "",
      }));
    } else {
      setForm((p) => ({
        ...p,
        mda_head_code: "",
        mda_head: "",
        send_to_office: "",
        projectType: "",
        mda_budget_balance: "",
        budget: "",
      }));
    }
  };

  const handleApi = () => {
    let list = selectedData;
    if (
      parseFloat(list[0].approved_amount) >
      parseFloat(list[0].mda_budget_balance)
    ) {
      setShowAmountWarningModal(true);
    } else {
      if (form.approval_no === "") {
        addToast("Please Complete the form", {
          appearance: "info",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
      } else {
        setIsLoading(true);
        form.sent_to_mda = form.sent_to.office || "";
        form.sent_to_office = form.sent_to.title || "";
        form.query_type = "insert";
        form.approval_status = "Approval Initiated";
        form.collection_date = moment().format("YYYY-MM-DD");
        form.approval_date = moment().format("YYYY-MM-DD");
        // list = list.map((item) => ({ ...item, narration: form.narration }));
        console.log(list, form);
        postApi(`post_approval_collection`, { list, form })
          .then((data) => {
            if (data.success) {
              // console.log(data, "FHDSSS========LLLDLLD");
              handleApi1(form.approval_no);
              const _newData = selectedData.map((i) => ({
                ...i,
                approval_no: form.approval_no,
                projectType: i.projectType,
              }));
              setSelectedData(_newData);
              addToast("submit success", {
                appearance: "info",
                autoDismiss: true,
                autoDismissTimeout: 5000,
              });
              setShowForm(false);
            }
          })
          .catch((err) => {
            alert(err);
            addToast(err, {
              appearance: "info",
              autoDismiss: true,
              autoDismissTimeout: 5000,
            });
          })
          .finally(() => {
            setIsLoading(false);
          });
        generateNarrationPDF();
      }
    }
  };

  const unClearhandleApiRelease = () => {
    setSubmittingReserveRequest(true);
    if (
      form.mda_name === "" ||
      form.mda_budget_balance == "" ||
      form.mda_code === "" ||
      form.approved_by === ""
    ) {
      alert("Please Complete the form");
      setSubmittingReserveRequest(false);
    } else {
      setIsLoading(true);
      form.sent_to_mda = form.sent_to.office || "";
      form.sent_to_office = form.sent_to.title || "";
      form.query_type = "insert";
      form.approval_status = "Unclear Released";

      postApi(`post_approval_collection`, { form })
        .then((data) => {
          if (data.success) {
            console.log(data);
            handleApi1(form.approval_no);
            const _newData = selectedData.forEach((i) => ({
              ...i,
              approval_no: form.approval_no,
            }));
            setSelectedData(_newData);
            addToast("submit success", {
              appearance: "info",
              autoDismiss: true,
              autoDismissTimeout: 5000,
            });
            setShowForm(false);
            setSubmittingReserveRequest(false);
          }
        })
        .catch((err) => {
          alert(err);
          addToast(err, {
            appearance: "info",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
          setShowForm(false);
          setSubmittingReserveRequest(false);
        })
        .finally(() => {
          setIsLoading(false);
          setSubmittingReserveRequest(false);
        });
    }
  };

  // const fetchMdaBankDetails = useCallback(() => {
  //   const query_type = "select";
  //   fetchApi(`select_mda_bank_details`, {
  //     query_type,
  //   })
  //     .then((data) => {
  //       console.log(data);
  //       setChildCode(data.result);
  //     })

  //     .catch((err) => {
  //       console.log(err);
  //     });

  //   console.log(childCode);
  // });

  // useEffect(() => {
  //   fetchMdaBankDetails();
  // }, [fetchMdaBankDetails]);

  // const clearEconomicTypeahead = () => {
  //   economicTypeahead.current.clear();
  // };
  const handleApi1 = (approval_no) => {
    // Only upload if there are files
    if (!attachedFiles || attachedFiles.length === 0) {
      console.log("No files to upload");
      return;
    }

    const formData = new FormData();

    // Add files to form data
    for (let i = 0; i < attachedFiles.length; i++) {
      formData.append("files", attachedFiles[i]);
    }

    // Create upload form with required fields
    const uploadForm = {
      mda_name: form.mda_name || form.mda_description,
      mda_code: form.mda_code,
      mda_economic_code: form.mda_economic_code,
      approved_by: form.approved_by,
      approval: form.approval || "Approved",
      imageId: form.imageId,
      narration: form.narration || "",
      approval_no: approval_no || form.approval_no,
    };

    formData.append("form", JSON.stringify(uploadForm));

    console.log("Uploading", attachedFiles.length, "files");
    console.log("Upload form:", uploadForm);

    fetch(`${apiURL}/post_images`, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((result) => {
        console.log("Upload result:", result);
        if (result.status === "success") {
          addToast(
            `${attachedFiles.length} attachment(s) uploaded successfully`,
            {
              appearance: "success",
              autoDismiss: true,
              autoDismissTimeout: 3000,
            },
          );
        }
      })
      .catch((err) => {
        console.error("Upload error:", err);
        addToast("Failed to upload attachments", {
          appearance: "error",
          autoDismiss: true,
          autoDismissTimeout: 5000,
        });
      });
  };

  const getApprovalById = useCallback(() => {
    if (_id) {
      fetchApi(
        `get-approve-col?id=${_id}`,
        (res) => {
          if (res.success) {
            setForm({
              ...res.result[0],
              approved_amount: res.result[0].amount,
              query_type: "update_app",
            });
          }
        },
        (err) => {
          addToast(`error occured ${err}`, {
            appearance: "error",
            autoDismiss: true,
            autoDismissTimeout: 5000,
          });
        },
      );
    }
  }, [_id]);

  useEffect(() => {
    getApprovalById();
  }, [getApprovalById]);

  return (
    <DashboardLayout>
      <MDBox pt={2} pb={3} pl={2}>
        <Grid container spacing={5}>
          {showForm ? (
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="success"
                  borderRadius="lg"
                  coloredShadow="info"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <MDTypography variant="h5" color="white">
                    New Release Collection
                  </MDTypography>
                  <Button
                    color="light"
                    size="sm"
                    onClick={() => navigate("/release-collection")}
                    style={{
                      backgroundColor: "rgba(255, 255, 255, 0.2)",
                      border: "1px solid white",
                      color: "white",
                      fontWeight: "500",
                    }}
                  >
                    ← Back to List
                  </Button>
                </MDBox>
                {/* Form Content */}
                <Row className="mt-1 px-4 py-4">
                  {/* Section: Release Type */}
                  <Col md={12} className="mb-3">
                    <div
                      style={{
                        backgroundColor: "#f8f9fa",
                        padding: "15px",
                        borderRadius: "8px",
                        borderLeft: "4px solid #4caf50",
                      }}
                    >
                      <MDTypography
                        variant="h6"
                        style={{ marginBottom: "10px", color: "#2c3e50" }}
                      >
                        Release Information
                      </MDTypography>
                    </div>
                  </Col>
                  {/* {JSON.stringify(form)} */}
                  <Col md={4}>
                    <Label style={{ fontWeight: "600", color: "#495057" }}>
                      Release Type <span style={{ color: "red" }}>*</span>
                    </Label>
                    <Input
                      type="select"
                      value={steps}
                      onChange={({ target: { value } }) => {
                        setSteps(value);
                        if (value === "1") {
                          setForm((p) => ({
                            ...p,
                            approval_type: "Recurrent",
                          }));
                        } else if (value === "2") {
                          setForm((p) => ({ ...p, approval_type: "Capital" }));
                        }
                      }}
                      style={{
                        borderRadius: "6px",
                        border: "1px solid #ced4da",
                        padding: "8px 12px",
                      }}
                    >
                      <option>--Select--</option>
                      <option value="1">Recurrent Project</option>
                      <option value="2">Capital Project</option>
                      <option value="3">Monthly Overhead</option>
                      <option value="4">Monthly Salary</option>
                      <option value="5">Other Overhead</option>
                    </Input>
                  </Col>
                  {/* {JSON.stringify({ form, selectedData })} */}
                  {steps === "3" || steps === "4" || steps === "5" ? (
                    <>
                      <Col md={8}>
                        <Label style={{ fontWeight: "600", color: "#495057" }}>
                          Narration <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          className="coloum"
                          type="textarea"
                          value={form.narration}
                          name="narration"
                          onChange={handleChange}
                          rows={5}
                          style={{
                            borderRadius: "6px",
                            border: "1px solid #ced4da",
                            padding: "10px",
                          }}
                        />
                        <div className="mt-2">
                          <Button
                            color="info"
                            size="sm"
                            outline
                            onClick={() => setShowNarrationModal(true)}
                          >
                            View full narration preview
                          </Button>
                        </div>
                      </Col>
                      <Col md={4}>
                        <Label style={{ fontWeight: "600", color: "#495057" }}>
                          Send to MDA
                        </Label>
                        <Typeahead
                          size="sm"
                          id="send-to-mda-typeahead"
                          onChange={(selected) => {
                            if (selected?.length) {
                              const selectedItem = selected[0];
                              setForm((p) => ({
                                ...p,
                                send_to_mda: selectedItem.admin_code,
                                send_to_mda_name:
                                  selectedItem.admin_description,
                              }));
                            } else {
                              setForm((p) => ({
                                ...p,
                                send_to_mda: "",
                                send_to_mda_name: "",
                              }));
                            }
                          }}
                          options={distinctAdmins.length ? distinctAdmins : []}
                          labelKey={(option) =>
                            `${option.admin_code} - ${option.admin_description}`
                          }
                          placeholder="Select MDA to send to"
                        />
                      </Col>
                      <Col md={4}>
                        <Label style={{ fontWeight: "600", color: "#495057" }}>
                          Reference Number
                        </Label>
                        <Input
                          value={form.approval_no}
                          name="approval_no"
                          onChange={handleChange}
                          style={{
                            borderRadius: "6px",
                            border: "1px solid #ced4da",
                            padding: "8px 12px",
                          }}
                        />
                      </Col>
                      {steps === "5" && (
                        <Col md={4}>
                          <Label
                            style={{ fontWeight: "600", color: "#495057" }}
                          >
                            Transaction Type{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            type="select"
                            value={form.projectType || ""}
                            name="projectType"
                            onChange={handleChange}
                            style={{
                              borderRadius: "6px",
                              border: "1px solid #ced4da",
                              padding: "8px 12px",
                            }}
                          >
                            <option value="">
                              --Select Transaction Type--
                            </option>
                            <option value="Overhead">Overhead</option>
                            <option value="Salary">Salary</option>
                            <option value="Personnel">Personnel</option>
                            <option value="Capital">Capital</option>
                          </Input>
                        </Col>
                      )}
                    </>
                  ) : null}

                  {/* {JSON.stringify({ selectedData })} */}
                  {steps === "1" || steps === "2" ? (
                    <>
                      {/* Date and Approval Section */}
                      <Col md={12} className="mt-4 mb-3">
                        <div
                          style={{
                            backgroundColor: "#f8f9fa",
                            padding: "15px",
                            borderRadius: "8px",
                            borderLeft: "4px solid #4caf50",
                          }}
                        >
                          <MDTypography
                            variant="h6"
                            style={{ marginBottom: "10px", color: "#2c3e50" }}
                          >
                            Approval Details
                          </MDTypography>
                        </div>
                      </Col>

                      <Col md={4}>
                        <Label style={{ fontWeight: "600", color: "#495057" }}>
                          Collection Date{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          type="date"
                          value={form.collection_date}
                          name="collection_date"
                          onChange={handleChange}
                          style={{
                            borderRadius: "6px",
                            border: "1px solid #ced4da",
                            padding: "8px 12px",
                          }}
                        />
                      </Col>
                      <Col md={4}>
                        <Label style={{ fontWeight: "600", color: "#495057" }}>
                          Approval Date <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          type="date"
                          value={form.approval_date}
                          name="approval_date"
                          onChange={handleChange}
                          style={{
                            borderRadius: "6px",
                            border: "1px solid #ced4da",
                            padding: "8px 12px",
                          }}
                        />
                      </Col>
                      <Col md={4}>
                        <Label style={{ fontWeight: "600", color: "#495057" }}>
                          Approved By <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          id="exampleSelect"
                          name="approved_by"
                          value={form.approved_by}
                          type="select"
                          onChange={handleChange}
                          style={{
                            borderRadius: "6px",
                            border: "1px solid #ced4da",
                            padding: "8px 12px",
                          }}
                        >
                          <option>--Select--</option>
                          <option value="HE">HE</option>
                        </Input>
                      </Col>

                      {/* MDA Selection Section */}
                      <Col md={12} className="mt-4 mb-3">
                        <div
                          style={{
                            backgroundColor: "#f8f9fa",
                            padding: "15px",
                            borderRadius: "8px",
                            borderLeft: "4px solid #4caf50",
                          }}
                        >
                          <MDTypography
                            variant="h6"
                            style={{ marginBottom: "10px", color: "#2c3e50" }}
                          >
                            MDA & Budget Information
                          </MDTypography>
                        </div>
                      </Col>

                      <Col md={4}>
                        <Label style={{ fontWeight: "600", color: "#495057" }}>
                          Select MDA to be charged{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Typeahead
                          size="sm"
                          id="20"
                          onChange={(selected) => handleMdaCode(selected)}
                          onInputChange={(text) => console.log(text)}
                          options={distinctAdmins.length ? distinctAdmins : []}
                          labelKey={(option) => `${option.admin_description}`}
                          placeholder="Select MDA"
                          ref={mdaRef}
                        />
                        {fetching && <Spinner size={"sm"} />}
                        <div
                          style={{
                            marginTop: "6px",
                            fontSize: "12px",
                            color: "#666",
                          }}
                        >
                          <strong>CC: </strong>
                          {form.mda_name ? (
                            form.copies?.officeTitle ? (
                              <span
                                style={{ color: "#e67e22", fontWeight: 500 }}
                              >
                                {form.copies.officeTitle}
                              </span>
                            ) : (
                              <span
                                style={{ color: "#999", fontStyle: "italic" }}
                              >
                                cc not set
                              </span>
                            )
                          ) : (
                            <span
                              style={{ color: "#999", fontStyle: "italic" }}
                            >
                              cc not set
                            </span>
                          )}
                        </div>
                      </Col>

                      <Col md={4}>
                        <Label style={{ fontWeight: "600", color: "#495057" }}>
                          Administrative Code
                        </Label>
                        <Input
                          type="number"
                          value={form.mda_code}
                          name="mda_code"
                          onChange={handleChange}
                          disabled
                          style={{
                            borderRadius: "6px",
                            border: "1px solid #ced4da",
                            padding: "8px 12px",
                            backgroundColor: "#e9ecef",
                          }}
                        />
                      </Col>
                      <Col md={4}>
                        <Label style={{ fontWeight: "600", color: "#495057" }}>
                          Select MDA Payable to (if any)
                        </Label>
                        <Typeahead
                          size="sm"
                          id="20"
                          onChange={(selected) => handleMdaCode1(selected)}
                          onInputChange={(text) => console.log(text)}
                          options={allMdaAdmins.length ? allMdaAdmins : []}
                          labelKey={(option) =>
                            `${option.admin_description}/${option.admin_code}`
                          }
                          placeholder="Select Head"
                        />
                        <div
                          style={{
                            marginTop: "6px",
                            fontSize: "12px",
                            color: "#666",
                          }}
                        >
                          <strong>CC: </strong>
                          {form.mda_head ? (
                            form.copies1?.officeTitle ? (
                              <span
                                style={{ color: "#e67e22", fontWeight: 500 }}
                              >
                                {form.copies1.officeTitle}
                              </span>
                            ) : (
                              <span
                                style={{ color: "#999", fontStyle: "italic" }}
                              >
                                cc not set
                              </span>
                            )
                          ) : (
                            <span
                              style={{ color: "#999", fontStyle: "italic" }}
                            >
                              cc not set
                            </span>
                          )}
                        </div>
                      </Col>

                      <Col md={4}>
                        <Label style={{ fontWeight: "600", color: "#495057" }}>
                          Select Economic Code{" "}
                          <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Typeahead
                          size="sm"
                          id="20"
                          onChange={(selected) => handleEconomicCode(selected)}
                          onInputChange={(text) => console.log(text)}
                          options={getDistinctObjects(
                            filteredEconomicCode.filter(
                              (item) =>
                                item.economic_code &&
                                item.economic_description &&
                                item.economic_code.trim() !== "" &&
                                item.economic_description.trim() !== "",
                            ),
                            "economic_code",
                            "economic_description",
                          )}
                          labelKey={(option) =>
                            `${option.economic_description} - ${option.economic_code}`
                          }
                          placeholder="Select Economic Code"
                          ref={economicRef}
                        />
                      </Col>
                      <Col md={4}>
                        <Label style={{ fontWeight: "600", color: "#495057" }}>
                          Description
                        </Label>
                        <Input
                          type="text"
                          value={form.description}
                          name="description"
                          onChange={handleChange}
                          disabled
                          style={{
                            borderRadius: "6px",
                            border: "1px solid #ced4da",
                            padding: "8px 12px",
                            backgroundColor: "#e9ecef",
                          }}
                        />
                      </Col>
                      {steps === "2" && (
                        <>
                          {/* Capital Project Codes Section */}
                          <Col md={12} className="mt-4 mb-3">
                            <div
                              style={{
                                backgroundColor: "#e3f2fd",
                                padding: "15px",
                                borderRadius: "8px",
                                borderLeft: "4px solid #2196f3",
                              }}
                            >
                              <MDTypography
                                variant="h6"
                                style={{
                                  marginBottom: "10px",
                                  color: "#1565c0",
                                }}
                              >
                                Capital Project Codes
                              </MDTypography>
                            </div>
                          </Col>

                          <Col md={4}>
                            <Label
                              style={{ fontWeight: "600", color: "#495057" }}
                            >
                              Select Fund Code
                            </Label>
                            <Typeahead
                              size="sm"
                              id="20"
                              ref={fundRef}
                              onChange={(selected) => {
                                if (selected && selected.length) {
                                  handleChange({
                                    target: {
                                      name: "fund_code",
                                      value: selected[0].fund_code,
                                    },
                                  });
                                  setForm((p) => ({
                                    ...p,
                                    fund_description:
                                      selected[0].fund_description,
                                  }));
                                }
                              }}
                              options={getDistinctObjects(
                                filteredEconomicCode.filter(
                                  (item) =>
                                    item.fund_code &&
                                    item.fund_description &&
                                    item.fund_code.trim() !== "" &&
                                    item.fund_description.trim() !== "",
                                ),
                                "fund_code",
                                "fund_description",
                              )}
                              labelKey={(option) =>
                                `${option.fund_code}/${option.fund_description}`
                              }
                              placeholder="Select Fund Code"
                            />
                          </Col>

                          <Col md={4}>
                            <Label
                              style={{ fontWeight: "600", color: "#495057" }}
                            >
                              Select Functional Code
                            </Label>
                            <Typeahead
                              size="sm"
                              id="20"
                              ref={functionalRef}
                              onChange={(selected) => {
                                if (selected && selected.length) {
                                  handleChange({
                                    target: {
                                      name: "functional_code",
                                      value: selected[0].functional_code,
                                    },
                                  });
                                  setForm((p) => ({
                                    ...p,
                                    functional_description:
                                      selected[0].functional_description,
                                  }));
                                }
                              }}
                              options={getDistinctObjects(
                                filteredEconomicCode.filter(
                                  (item) =>
                                    item.functional_code &&
                                    item.functional_description &&
                                    item.functional_code.trim() !== "" &&
                                    item.functional_description.trim() !== "",
                                ),
                                "functional_code",
                                "functional_description",
                              )}
                              labelKey={(option) =>
                                `${option.functional_code}/${option.functional_description}`
                              }
                              placeholder="Select Functional Code"
                            />
                          </Col>

                          <Col md={4}>
                            <Label
                              style={{ fontWeight: "600", color: "#495057" }}
                            >
                              Select Program Code
                            </Label>
                            <Typeahead
                              size="sm"
                              id="20"
                              ref={programRef}
                              onChange={(selected) => {
                                if (selected && selected.length) {
                                  handleChange({
                                    target: {
                                      name: "program_code",
                                      value: selected[0].program_code,
                                    },
                                  });
                                  setForm((p) => ({
                                    ...p,
                                    program_description:
                                      selected[0].program_description,
                                  }));
                                }
                              }}
                              options={getDistinctObjects(
                                filteredEconomicCode.filter(
                                  (item) =>
                                    item.program_code &&
                                    item.program_description &&
                                    item.program_code.trim() !== "" &&
                                    item.program_description.trim() !== "",
                                ),
                                "program_code",
                                "program_description",
                              )}
                              labelKey={(option) =>
                                `${option.program_code}/${option.program_description}`
                              }
                              placeholder="Select Program Code"
                            />
                          </Col>

                          <Col md={4}>
                            <Label
                              style={{ fontWeight: "600", color: "#495057" }}
                            >
                              Select Geo Code
                            </Label>
                            <Typeahead
                              size="sm"
                              id="20"
                              ref={geoRef}
                              onChange={(selected) => {
                                if (selected && selected.length) {
                                  handleChange({
                                    target: {
                                      name: "geo_code",
                                      value: selected[0].geo_code,
                                    },
                                  });
                                  setForm((p) => ({
                                    ...p,
                                    geo_description:
                                      selected[0].geo_description,
                                  }));
                                }
                              }}
                              options={getDistinctObjects(
                                filteredEconomicCode.filter(
                                  (item) =>
                                    item.geo_code &&
                                    item.geo_description &&
                                    item.geo_code.trim() !== "" &&
                                    item.geo_description.trim() !== "",
                                ),
                                "geo_code",
                                "geo_description",
                              )}
                              labelKey={(option) =>
                                `${option.geo_code}/${option.geo_description}`
                              }
                              placeholder="Select Geo Code"
                            />
                          </Col>
                        </>
                      )}

                      {/* Budget and Amount Section */}
                      <Col md={12} className="mt-4 mb-3">
                        <div
                          style={{
                            backgroundColor: "#fff3e0",
                            padding: "15px",
                            borderRadius: "8px",
                            borderLeft: "4px solid #ff9800",
                          }}
                        >
                          <MDTypography
                            variant="h6"
                            style={{ marginBottom: "10px", color: "#e65100" }}
                          >
                            Budget & Amount Details
                          </MDTypography>
                        </div>
                      </Col>

                      <Col md={4}>
                        <Label style={{ fontWeight: "600", color: "#495057" }}>
                          Approved Budget Allocation
                        </Label>
                        <Input
                          value={
                            isNaN(form.budget)
                              ? form.budget
                              : formatNumber(form.budget)
                          }
                          name="budget"
                          onChange={handleChange}
                          disabled
                          style={{
                            borderRadius: "6px",
                            border: "1px solid #ced4da",
                            padding: "8px 12px",
                            backgroundColor: "#e9ecef",
                            fontWeight: "600",
                            color: "#2c3e50",
                          }}
                        />
                      </Col>
                      <Col md={4}>
                        <Label style={{ fontWeight: "600", color: "#495057" }}>
                          Budget Balance
                        </Label>
                        <div style={{ position: "relative" }}>
                          <Input
                            value={
                              isNaN(form.mda_budget_balance)
                                ? form.mda_budget_balance
                                : formatNumber(form.mda_budget_balance)
                            }
                            name="mda_budget_balance"
                            onChange={handleChange}
                            disabled
                            style={{
                              borderRadius: "6px",
                              border: "1px solid #ced4da",
                              padding: "8px 12px",
                              backgroundColor: "#e9ecef",
                              fontWeight: "600",
                              color:
                                form.mda_budget_balance === "Budget Exausted"
                                  ? "#d32f2f"
                                  : "#2c3e50",
                            }}
                          />
                          {balLoanding && (
                            <Spinner
                              size={"sm"}
                              color="success"
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                              }}
                            />
                          )}
                        </div>
                      </Col>

                      <Col md={4}>
                        <Label style={{ fontWeight: "600", color: "#495057" }}>
                          Approved Amount{" "}
                          <span style={{ color: "red" }}>*</span>
                          <span
                            style={{
                              color: "#4caf50",
                              fontSize: "14px",
                              marginLeft: "8px",
                            }}
                          >
                            ({formatNumber(form.approved_amount)})
                          </span>
                        </Label>
                        <Input
                          type="number"
                          value={form.approved_amount}
                          name="approved_amount"
                          onChange={handleChange}
                          style={{
                            borderRadius: "6px",
                            border: "2px solid #4caf50",
                            padding: "8px 12px",
                            fontWeight: "600",
                          }}
                        />
                      </Col>
                      <Col md={4}>
                        <Label style={{ fontWeight: "600", color: "#495057" }}>
                          Reference No <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          value={form.approval_no}
                          name="approval_no"
                          onChange={handleChange}
                          style={{
                            borderRadius: "6px",
                            border: "1px solid #ced4da",
                            padding: "8px 12px",
                          }}
                        />
                      </Col>
                      <Col md={4}>
                        <Label style={{ fontWeight: "600", color: "#495057" }}>
                          Copy to (Select MDA if any)
                        </Label>
                        <Typeahead
                          size="sm"
                          id="cc-mda-typeahead"
                          onChange={(selected) => {
                            if (selected?.length) {
                              const selectedItem = selected[0];
                              setForm((p) => ({
                                ...p,
                                cc: selectedItem.admin_description,
                                cc_mda_name: selectedItem.admin_description,
                              }));
                            } else {
                              setForm((p) => ({
                                ...p,
                                cc: "",
                                cc_mda_name: "",
                                cc_copies: {},
                              }));
                            }
                          }}
                          options={
                            allMdaAdmins.length ? allMdaAdmins : distinctAdmins
                          }
                          labelKey={(option) => `${option.admin_description}`}
                          placeholder="Select MDA for CC"
                          ref={ccMdaRef}
                        />
                        <div
                          style={{
                            marginTop: "6px",
                            fontSize: "12px",
                            color: "#666",
                          }}
                        >
                          <strong>CC: </strong>
                          {form.cc_mda_name ? (
                            form.cc ? (
                              <span
                                style={{ color: "#e67e22", fontWeight: 500 }}
                              >
                                {form.cc}
                              </span>
                            ) : (
                              <span
                                style={{ color: "#999", fontStyle: "italic" }}
                              >
                                cc not set
                              </span>
                            )
                          ) : (
                            <span
                              style={{ color: "#999", fontStyle: "italic" }}
                            >
                              cc not set
                            </span>
                          )}
                        </div>
                      </Col>
                      <Col md={12} className="mt-3">
                        <Label style={{ fontWeight: "600", color: "#495057" }}>
                          Narration <span style={{ color: "red" }}>*</span>
                        </Label>
                        <div
                          style={{
                            border: "1px solid #ced4da",
                            borderRadius: "6px",
                            padding: "5px",
                            backgroundColor: "#fff",
                          }}
                        >
                          <Input
                            className="coloum"
                            type="textarea"
                            value={form.narration}
                            name="narration"
                            onChange={handleChange}
                            rows={5}
                            style={{
                              border: "none",
                              outline: "none",
                            }}
                          />
                        </div>
                        <div className="mt-2">
                          <Button
                            color="info"
                            size="sm"
                            outline
                            onClick={() => setShowNarrationModal(true)}
                          >
                            View full narration preview
                          </Button>
                        </div>
                      </Col>
                      {form.mda_code !== "" && form.mda_budget_balance === 0 ? (
                        <Col md={12} className="mt-3">
                          <Alert
                            color="primary"
                            style={{
                              borderRadius: "8px",
                              border: "1px solid #2196f3",
                              backgroundColor: "#e3f2fd",
                            }}
                          >
                            <center style={{ fontWeight: "600" }}>
                              Please select the corresponding line item
                            </center>
                          </Alert>
                        </Col>
                      ) : null}

                      {/* Attachment Section */}
                      <Col md={12} className="mt-4 mb-3">
                        <div
                          style={{
                            backgroundColor: "#f3e5f5",
                            padding: "15px",
                            borderRadius: "8px",
                            borderLeft: "4px solid #9c27b0",
                          }}
                        >
                          <MDTypography
                            variant="h6"
                            style={{ marginBottom: "10px", color: "#6a1b9a" }}
                          >
                            Attachments (Optional) Image only
                          </MDTypography>
                        </div>
                      </Col>

                      <Col md={12} className="py-2 px-4">
                        <Attachment
                          acceptedFiles={attachedFiles}
                          getRootProps={getRootProps}
                          getInputProps={getInputProps}
                          isDragActive={isDragActive}
                          onDeleteFile={handleDeleteAttachment}
                        />
                      </Col>

                      {/* Action Buttons */}
                      <Col md={12} className="mt-4 mb-3">
                        <div
                          style={{
                            borderTop: "2px solid #e0e0e0",
                            paddingTop: "20px",
                          }}
                        >
                          <center>
                            <Button
                              color="success"
                              onClick={handleAddToList}
                              size="lg"
                              disabled={isLoading}
                              style={{
                                borderRadius: "8px",
                                padding: "12px 40px",
                                fontWeight: "600",
                                boxShadow: "0 4px 6px rgba(76, 175, 80, 0.3)",
                              }}
                            >
                              {isLoading ? (
                                <>
                                  <Spinner color="light" size="sm" />{" "}
                                  <span style={{ marginLeft: "8px" }}>
                                    Validating...
                                  </span>
                                </>
                              ) : (
                                <>
                                  <i
                                    className="fas fa-plus-circle"
                                    style={{ marginRight: "8px" }}
                                  ></i>
                                  Add to Batch
                                </>
                              )}
                            </Button>
                          </center>
                        </div>
                      </Col>

                      <SelectedDataTable
                        selectedData={selectedData}
                        showTable={showTable}
                        onDelete={handleDeleteFromList}
                      />

                      {selectedData?.length ? (
                        <Col md={12} className="mt-3 mb-4">
                          <center>
                            <Button
                              color="primary"
                              onClick={isLoading ? "" : handleApi}
                              disabled={isLoading}
                              size="lg"
                              style={{
                                borderRadius: "8px",
                                padding: "12px 50px",
                                fontWeight: "600",
                                boxShadow: "0 4px 6px rgba(33, 150, 243, 0.3)",
                              }}
                            >
                              {isLoading ? (
                                <Spinner color="light" size="sm" />
                              ) : (
                                <>
                                  <i
                                    className="fas fa-paper-plane"
                                    style={{ marginRight: "8px" }}
                                  ></i>
                                  Submit Release
                                </>
                              )}
                            </Button>
                          </center>
                        </Col>
                      ) : null}
                    </>
                  ) : // : steps === "3" ? (
                  //   <CapitalProject generalForm={form} />
                  // )
                  steps === "5" ? (
                    <OtherOverheadExcelUpload form={form} setForm={setForm} />
                  ) : (
                    <NewRecurrentMonthly steps={steps} form={form} />
                  )}
                </Row>
                <WarningModal
                  showModal={showAmountWarningModal}
                  setShowModal={setShowAmountWarningModal}
                  handleSubmit={submitPlanningReserveRequest}
                  form={form}
                  loading={submittingReserveRequest}
                  handleApi={unClearhandleApiRelease}
                />
                <Modal
                  isOpen={showNarrationModal}
                  toggle={() => setShowNarrationModal(false)}
                  size="lg"
                >
                  <ModalHeader toggle={() => setShowNarrationModal(false)}>
                    Full Narration Preview
                  </ModalHeader>
                  <ModalBody>
                    <p style={{ fontSize: "15px", lineHeight: 1.6 }}>
                      I am directed to convey approval for the release of{" "}
                      <strong>
                        (N{formatNumber(Number(form.approved_amount))}) only
                      </strong>{" "}
                      to{" "}
                      {form.copies1?.officeTitle
                        ? `${form.copies?.officeTitle || ""}  payable to ${form.copies1.officeTitle}`
                        : form.copies?.officeTitle || ""}{" "}
                      {form.narration}.
                    </p>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color="secondary"
                      onClick={() => setShowNarrationModal(false)}
                    >
                      Close
                    </Button>
                  </ModalFooter>
                </Modal>
              </Card>
            </Grid>
          ) : (
            <>
              {selectedData?.length === 1 ? (
                <RealiseCollectionPdfWebView
                  form={selectedData[0]}
                  selecOffer={formatNumber}
                />
              ) : (
                <NewRelisePdfWebView
                  selectedData={selectedData}
                  selecOffer={formatNumber}
                />
              )}
            </>
          )}
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}
